export const typeMapper: Record<string, string> = {
  gold: 'DGLD',
  silver: 'DSLR',
};

export const typeNameMapper: Record<string, string> = {
  gold: 'Gold',
  silver: 'Silver',
};
